import React from "react";
import Layout from "../../components/layout";
import NotFound from '../../assets/images/not-found.png'
import { useTranslation } from "react-i18next";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";

const NotFoundPage : React.FC = () => {
  const {t} = useTranslation()
  const navigate = useNavigate()
  return(
    <>
      <img src={NotFound} alt="not found page" className="60% mx-auto mt-20"/>
      <h3 className="text-center text-[20px] font-bold">{t('Something went wrong')}</h3>
      <p className="text-center my-3">{t('Sorry, We can’t find the page you’re looking for.')}</p>
      <Button className="text-center block mx-auto" type="primary" onClick={() => navigate('/')}>{t('Home')}</Button>
    </>
  )
}

export default NotFoundPage